// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__7s9H9","inputWrap":"CustomTip_inputWrap__EQvAj"};